import {
  Box,
  Button,
  ButtonProps,
  Dialog,
  DialogProps,
  Typography,
  TypographyProps,
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material';
import React from 'react';

import { darkPurple, white } from 'utils/color-styles';

export type ModalContentsProps = {
  header?: JSX.Element | string;
  headerStyles?: Record<string, unknown>;
  body: React.ReactNode | string;
  actions?: JSX.Element;
  onClickClose?: () => void;
};

export const ModalContents = ({
  header,
  headerStyles,
  body,
  actions,
  onClickClose,
}: ModalContentsProps): JSX.Element => (
  <>
    {header ? (
      <Box
        style={{
          backgroundColor: darkPurple,
          textAlign: 'center',
          ...headerStyles,
        }}
      >
        {header}
        {onClickClose ? (
          <CloseIcon
            style={{
              cursor: 'pointer',
              marginBottom: 20,
              position: 'absolute',
              background: white,
              borderRadius: 50,
              width: 30,
              height: 30,
              margin: 18,
              top: 0,
              right: 0,
            }}
            onClick={onClickClose}
          />
        ) : null}
      </Box>
    ) : null}

    <Box p={4}>{body}</Box>

    {actions ? (
      <Box p={4} pt={0} display="flex" justifyContent="flex-end" alignItems="flex-end">
        {actions}
      </Box>
    ) : null}
  </>
);

export const ModalTitle = ({
  style,
  size,
  ...props
}: TypographyProps & {
  size?: 'large' | 'medium';
}): JSX.Element => (
  // @ts-expect-error TypographyProps somehow cannot be passed in Typography
  <Typography
    variant="h4"
    component="h4"
    // @TODO-DP: instead of doing these hacks we should rather setup MUI typography correctly
    style={{
      fontWeight: 400,
      fontSize: size === 'large' ? 28 : 20,
      marginBottom: size === 'large' ? 24 : 12,
      ...style,
    }}
    {...props}
  />
);

export const ModalTypography = ({ style, ...props }: TypographyProps): JSX.Element => {
  const theme = useTheme();
  return (
    // @ts-expect-error TypographyProps somehow cannot be passed in Typography
    <Typography
      variant="body2"
      component="p"
      style={{ fontSize: 14, color: theme.palette.text.primary, marginBottom: 16, ...style }}
      {...props}
    />
  );
};

export const ModalButton = ({ style, ...props }: ButtonProps): JSX.Element => (
  <Button color="primary" type="button" variant="contained" style={{ ...style }} {...props} />
);

export const Modal = ({
  disableEnforceFocus,
  PaperProps,
  width = 800,
  ...props
}: DialogProps & { width?: number }): JSX.Element => (
  <Dialog
    disableEnforceFocus={disableEnforceFocus}
    PaperProps={{
      square: true,
      style: {
        marginTop: 100,
        borderRadius: 4,
        width,
        maxHeight: 'calc(100% - 120px)',
        maxWidth: 'calc(100% - 120px)',
      },
      ...PaperProps,
    }}
    {...props}
  />
);

export default Modal;
